export function toBool(val) {
    if (val === true || val === 1 || val === '1' || val === 'true') return true;
    if (val === false || val === 0 || val === '0' || val === 'false') return false;
    return !!val;
}

export function toNumber(val, fallback = 0) {
    if (typeof val === 'string') {
        val = val.trim().replace(',', '.');
    }
    const n = parseFloat(val);
    return isNaN(n) ? fallback : n;
}

export function normalizeProbability(val) {
    if (typeof val === 'string') {
        val = val.trim().replace(',', '.');
    }
    val = parseFloat(val);
    if (isNaN(val) || val < 0 || val > 100) return 100;
    return val;
}

export function normalizeStyle(style) {
    if (!style) return style;
    const s = { ...style };
    s.showAvatar = toBool(s.showAvatar);
    s.canBeClosed = toBool(s.canBeClosed);
    s.showBranding = s.branding ? toBool(s.branding.showBranding) : toBool(s.showBranding);
    s.canBeMinimized = toBool(s.canBeMinimized);
    s.showProgressBar = toBool(s.showProgressBar);
    s.showOverlay = toBool(s.showOverlay);
    s.blurBackground = toBool(s.blurBackground);
    s.goBack = toBool(s.goBack);

    if (s.progressBarSettings) {
        s.progressBarSettings = { ...s.progressBarSettings };
        s.progressBarSettings.showProgressNumber = toBool(s.progressBarSettings.showProgressNumber);
        s.progressBarSettings.excludeOptionalQuestions = toBool(s.progressBarSettings.excludeOptionalQuestions);
    }

    if (s.background) {
        s.background = { ...s.background };
        s.background.enableBackgroundImage = toBool(s.background.enableBackgroundImage);
        s.background.enableBackgroundOverlay = toBool(s.background.enableBackgroundOverlay);
    }

    if (s.standaloneInfo) {
        s.standaloneInfo = { ...s.standaloneInfo };
        s.standaloneInfo.enableTitle = toBool(s.standaloneInfo.enableTitle);
        s.standaloneInfo.enableSubtitle = toBool(s.standaloneInfo.enableSubtitle);
        s.standaloneInfo.enableExtraButton = toBool(s.standaloneInfo.enableExtraButton);
        s.standaloneInfo.contentPosition = s.standaloneInfo.contentPosition || 'left';
    }

    if (s.header) {
        s.header = { ...s.header };
        if (s.header.showHeader !== undefined) s.header.showHeader = toBool(s.header.showHeader);
    }

    if (s.branding) {
        s.branding = { ...s.branding };
        if (s.branding.showBranding !== undefined) s.branding.showBranding = toBool(s.branding.showBranding);
    }

    return s;
}

export function normalizeQuestion(q) {
    if (!q) return q;
    const nq = { ...q };
    nq.isObligated = toBool(nq.isObligated);
    nq.isActive = toBool(nq.isActive);
    if (nq.showOptIn !== undefined) nq.showOptIn = toBool(nq.showOptIn);
    if (nq.showMoreCheckbox !== undefined) nq.showMoreCheckbox = toBool(nq.showMoreCheckbox);
    if (nq.checkboxObligated !== undefined) nq.checkboxObligated = toBool(nq.checkboxObligated);
    if (nq.customized !== undefined) nq.customized = toBool(nq.customized);
    if (nq.isColored !== undefined) nq.isColored = toBool(nq.isColored);
    return nq;
}

export function normalizeCan(can) {
    if (!can) return {};
    const c = { ...can };
    c.customBranding = toBool(c.customBranding);
    c.customCss = toBool(c.customCss);
    return c;
}

export function normalizeSurveySettings(settings) {
    if (!settings) return settings;
    const s = { ...settings };
    s.isJsTargetingEnabled = toBool(s.isJsTargetingEnabled);
    if (s.proportionOfUsers !== undefined) {
        s.proportionOfUsers = normalizeProbability(s.proportionOfUsers);
    }
    if (s.secondsAfterLoad !== undefined) {
        s.secondsAfterLoad = toNumber(s.secondsAfterLoad, 0);
    }
    if (s.scrollPercentage !== undefined) {
        s.scrollPercentage = toNumber(s.scrollPercentage, 50);
    }
    return s;
}
